import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(auth)/sign-up/(funnel)/register/page.tsx");
